import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { DeviceDetect } from "sb-resp-utils";
import { internalMessageBus } from "sb-internal-msg-bus";
import { BaseDict } from "./dict";
import { SuperBanner } from "./SuperBanner";
import { SuperBannerData } from "./data";
import { DataParser } from "../../parser/DataParser";
import { DataFacade } from "../../data/DataFacade";
import { SuperBannerConfiguration, getEventIdsFromConfiguration } from "../../data";
/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import { SportDataGateWayRetriever } from "../../data";
import { oddsFormatter } from "./helpers";
import { DeviceDetectHelper } from "../../parser";
import { DecimalLocalizator } from "sb-helpers";
import { SportDataGateway } from "sb-bff-integration";
let SportDataGateWayRetrieverMock;
let UserInfoMock;
let CurrentOddStyleMock;
let NavHandlerMock;
let TimeControlMock;
let deviceDetectMock;
let uiPreferencesMock;
let clientIncludeInManagerMockInstance;
if (process.env.NODE_ENV === "development") {
    let _libMocks = require("sb-legacy-integration/lib-esm/mocks");
    let _localMocks = require("../../mocks");
    SportDataGateWayRetrieverMock = _localMocks.SportDataGateWayRetrieverMock;
    UserInfoMock = _libMocks.UserInfoMock;
    CurrentOddStyleMock = _localMocks.CurrentOddStyleCodeMock;
    NavHandlerMock = _libMocks.NavHandlerMock;
    TimeControlMock = _libMocks.TimeControlMock;
    uiPreferencesMock = _localMocks.uiPreferencesMock;
    deviceDetectMock = new _localMocks.DeviceDetectMock();
    clientIncludeInManagerMockInstance = _localMocks.ClientIncludeInManagerMockInstance;
    window["_cmsResponseTestCasesMock"] = _localMocks.CMSResponseTestCasesMock;
}
export class SuperBannerRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        gameStatus: {},
        timeControl: {},
        userInfo: {},
        panelId: ""
    }) {
        super(domId, options);
        let decimalLocalizator = new DecimalLocalizator({
            oddFormatters: window["BetFormat"],
            pointFormatter: window["PointsFormat"],
            numberFormatter: window["NumberFormat"]
        });
        if (process.env.NODE_ENV === "development") {
            let cmsConfig = new SuperBannerConfiguration(options.cms, clientIncludeInManagerMockInstance);
            let eventIdsMock = getEventIdsFromConfiguration(options.cms);
            const htmlEl = document.documentElement;
            if (htmlEl) {
                htmlEl.classList.contains("IsDesktop") ? deviceDetectMock.setToDesktop() : deviceDetectMock.setToMobile();
            }
            this.dataFacade = new DataFacade({
                eventsIds: eventIdsMock,
                sportDataGatewayRetriever: new SportDataGateWayRetrieverMock(),
                currentOddStyleIndex: CurrentOddStyleMock,
                userInfo: UserInfoMock,
                cms: cmsConfig,
                blockUniqueId: domId, utils: {
                    deviceDetect: new DeviceDetectHelper(deviceDetectMock),
                    navHandler: new NavHandlerMock(),
                    timeControl: new TimeControlMock(new Date())
                },
                currentSelectedSportId: 0,
                messageBus: internalMessageBus,
                dateFormat: uiPreferencesMock.dateFormat,
                timeFormat: uiPreferencesMock.timeFormat,
                isMBNEnabled: options.dataProvider.isMBNEnabled
            });
            let dataParser = new DataParser(this.dataFacade, decimalLocalizator);
            const data = {
                provider: dataParser,
                oddsFormatHelper: oddsFormatter,
                clientIncludeInManager: clientIncludeInManagerMockInstance,
                dict: options.dict
            };
            this.dataProvider = new SuperBannerData(data);
        }
        if (process.env.NODE_ENV === "production" /* && typeof options.dataProvider !== "undefined"*/) {
            let cmsConfig = new SuperBannerConfiguration(options.cms, options.dataProvider.clientIncludeInManager);
            let eventsIds = getEventIdsFromConfiguration(options.cms);
            this.dataFacade = new DataFacade({
                sportDataGatewayRetriever: new SportDataGateWayRetriever(new SportDataGateway()),
                eventsIds,
                currentOddStyleIndex: options.dataProvider.oddStyleCode,
                cms: cmsConfig,
                userInfo: options.userInfo,
                blockUniqueId: domId,
                currentSelectedSportId: 0,
                utils: {
                    deviceDetect: new DeviceDetectHelper(DeviceDetect.getInstance()),
                    navHandler: options.navHandler,
                    timeControl: options.timeControl
                },
                messageBus: options.dataProvider.messageBus,
                dateFormat: options.dataProvider.dateFormat,
                timeFormat: options.dataProvider.timeFormat,
                isMBNEnabled: options.dataProvider.isMBNEnabled
            });
            let highlightsDataParser = new DataParser(this.dataFacade, decimalLocalizator); //, this.options.cms, DeviceDetect.getInstance()
            const data = {
                provider: highlightsDataParser,
                oddsFormatHelper: oddsFormatter,
                clientIncludeInManager: options.dataProvider.clientIncludeInManager,
                dict: options.dict
            };
            this.dataProvider = new SuperBannerData(data);
        }
        window["dataProvider"] = this.dataProvider;
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
    }
    setParams(branchId) {
        const parsedId = parseInt(branchId);
        const id = isNaN(parsedId) ? 0 : parsedId;
        this.dataFacade.setCurrentSelectedSportId(id);
    }
    activate() {
        this.dataFacade.activate();
        this.dataProvider.updateClientIncludeData();
        return super.activate(
        // hardcoded rtl for testing purposes
        React.createElement(SuperBanner, { dataProvider: this.dataProvider, dict: this.options.dict, cms: (new SuperBannerConfiguration(this.options.cms, this.dataProvider.clientIncludeInManager) || {}) }));
    }
    deactivate() {
        this.dataFacade.deactivate();
        return super.deactivate();
    }
}
window["SuperBanner"] = SuperBannerRoot;
broadcastBlockLoad("SuperBanner");
//# sourceMappingURL=index.js.map